import { observer } from 'mobx-react';
import React from 'react';
import placementTestGlobalTotalService from '../services/PlacementTestGlobalTotalService';
import PlacementTestReportGlobalTab from './PlacementTestReportGlobalTab';

function PlacementTestReportGlobalTabContainer() {
  return (
    <PlacementTestReportGlobalTab
      total={placementTestGlobalTotalService.total}
      isFetching={placementTestGlobalTotalService.fetch.fetching}
    />
  );
}

export default observer(PlacementTestReportGlobalTabContainer);
